module.exports = __webpack_public_path__ + "img/search.c566adb4.svg";